import { Col, Row } from "react-bootstrap";
import { useBundleContext } from "../../context/BundlesContext";
import { toCurrency } from "../../helpers";
import { BlockCheckbox } from "../fields";
export const Bundles = () => {
  const { available_bundles, onSelect } = useBundleContext();
  const handleChange = (_event, change, sku) => {
    onSelect(sku, change);
  };

  if (!available_bundles.length) return null;
  return (
    <>
      <h2 className="mb-4">Bundle Quick Order</h2>
      <p>This square footage qualifies for these product bundles!</p>
      <Row>
        {available_bundles.map((bundle) => {
          return (
            <Col key={bundle.sku} sm={4} className="mb-5">
              <BlockCheckbox
                label={bundle.name}
                sku={bundle.sku}
                col={false}
                onChange={handleChange}
                custom_price={`${toCurrency(bundle.subtotal, "+")}`}
                discount={`${toCurrency(bundle.total, "+")}`}
                description={bundle.description}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};
